export default __webpack_public_path__ + "static/media/image-work-personal-m@2x.221a7642.png";